import React from 'react';
import Button from '@material-ui/core/Button';
import Map, {MapProps} from '../map2';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {theme} from '../../styles';
import {autobind} from 'core-decorators';

interface Link {
    center: [number, number];
    zoom: number;
    text: string;
}

interface MapWithLinksProps extends MapProps {
    links: Link[];
}

export default class MapWithLinks extends React.Component<MapWithLinksProps> {
    map: mapboxgl.Map | undefined;

    render() {
        const {links, ...mapProps} = this.props;
        return (
            <MuiThemeProvider theme={theme}>
                <div>
                    <div style={{
                        margin: '0 auto',
                        marginBottom: 20,
                        height: 400,
                        width: '100%',
                        textAlign: 'left',
                        maxWidth: 800
                    }}>
                        <Map
                            mapboxRef={this.mapboxRef}
                            style={{height: 400}}
                            {...mapProps}
                        />
                    </div>
                    <div style={{
                        flexWrap: 'wrap',
                        margin: '0 auto',
                        textAlign: 'center',
                        maxWidth: 600,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        width: '100%'
                    }}>
                        {links.map(({text, center, zoom}: Link, i: number) => (
                            <Button
                                key={i}
                                color="primary"
                                onClick={() => this.map && this.map.flyTo({speed: 2, center, zoom})}
                                style={{marginBottom: 12}}
                                variant="contained">
                                {text}
                            </Button>
                        ))}
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }

    @autobind
    mapboxRef(map: mapboxgl.Map) {
        this.map = map;
    }
}
